import { runWithAdal } from 'react-adal';
//import { authContext } from './adalConfig';
import { adalConfigOptions } from './adalConfig';
const DO_NOT_LOGIN = true;

adalConfigOptions.then(
    configValues =>
        runWithAdal(configValues.authContext, () => {
        require('./indexApp.js');
    }, DO_NOT_LOGIN)
);


//runWithAdal(AdalConfigVal.authContext, () => {

//    // eslint-disable-next-line
//    const loggedinAdalInstance = window.parent._adalInstance;

//    //check user profile
//    //if (authContext._user.profile.groups.indexOf("b9c206ac-db8f-402b-b251-c14e7cc29187") != -1) {
//    require('./indexApp.js');

//    //}
//    //else {
//    //    alert("Dn't have access")
//    //}
//}, DO_NOT_LOGIN);



// WEBPACK FOOTER //
// ./src/index.js